import { createAsyncThunk } from "@reduxjs/toolkit";
import { adminAPI } from "../api";
import { toast } from "react-toastify";

export const blockRegisterToDistance = createAsyncThunk(
  "admin/createMarathon",
  async (body: any, { rejectWithValue }) => {
    try {
      const { data } = await adminAPI.blockRegisterToDistance(body);
      toast.success('Статус регистрации успешно изменён');
      return data;
    } catch (error: any) {
      toast.error('Ошибка при изменении статуса регистрации');
      return rejectWithValue("Error in creation a marathon");
    }
  }
);